export { default } from "./updatePhone";
